import React from "react";

interface EmptyRowProps {
  children: React.ReactNode;
}

// One empty line for every feed widget, so an idle dashboard reads as calm rather than broken.
const EmptyRow: React.FC<EmptyRowProps> = ({ children }) => (
  <p className="eai-description-sm">{children}</p>
);

export default EmptyRow;
